import React, { useState, useEffect } from "react";
import Header from "./Header";
import ExamHeader from "./ExamHeader";
import QuestionSection from "./QuestionSection";
import Sidebar from "./Sidebar";
import { useQuestion } from "../../../context/QuestionsContext";
import { useQuestionSection } from "../../../hooks/default/useQuestionSection";
import SubmissionPopupReLogin from "../../../components/popups/SubmissionPopupReLogin";
import SubmissionPopup from "../../../components/popups/SubmissionPopup";
import ServerErrorDialog from "../../../components/popups/ServerErrorDialog";
import FinalSubmissionDialog from "../../../components/popups/FinalSubmissionDialog";
import {
  Typography,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import oip from "../../../images/OIP.jpeg";

function FeedbackTest() {
  const { question } = useQuestion();

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [currentQuestionBySubject, setCurrentQuestionBySubject] = useState(0);
  const [currentSubject, setCurrentSubject] = useState("");
  const [subjectId, setSubjectId] = useState("");

  const questionData = question?.subjects
    ?.map((subject) => subject?.questions)
    .flat();


  const [expandedSubject, setExpandedSubject] = useState(null);

  // Toggle expand/collapse
  const toggleSubject = (name) => {
    setExpandedSubject((prev) => (prev === name ? null : name));
  };

  const subjects = question?.subjects;

  const {
    selectedOptionId,
    showSubmissionPopup,
    showSubmissionPopupReLogin,
    showServerErrorDialog,
    setShowServerErrorDialog,
    showSubmitModal,
    isTimeUp,
    setIsTimeUp,
    countdownTime,
    finalSubmitChecked,
    submitError,
    countdownByHead,
    stats,
    handleOptionChange,
    handleMultipleChoiceChange,
    handleInputChange,
    resetSelections,
    handleSaveNextDefault,
    handleMarkReviewDefault,
    handleClearResponse,
    handleBack,
    handleSave,
    handleNext,
    handleOpenSubmitModal,
    handleCloseSubmitModal,
    handleFinalSubmitCheck,
    handleFinalSubmit,
    setOpenMandatory,
    openMandatory,
  } = useQuestionSection({
    questionData,
    currentQuestion,
    setCurrentQuestion,
    subjectId,
  });

  useEffect(() => {
    if (question) {
      setCurrentSubject(question?.subjects[0].subject_name);
      setExpandedSubject(question?.subjects[0].subject_name)
      setSubjectId(question?.subjects[0].id);
    }
  }, [question]);

  // const preTotal = (subjectId) => {
  //   if (!Array.isArray(subjects) || subjects.length === 0) return false;

  //   const index = subjects.findIndex(
  //     (subject) => Number(subject.id) === Number(subjectId)
  //   );
  //   if (index <= 0) return false; // if first subject or not found

  //   const total = subjects
  //     .slice(0, index)
  //     .reduce((sum, subj) => sum + (subj.subject_question_count || 0), 0);

  //   return total === currentQuestion;
  // };

  // useEffect(() => {
  //   if (!questionData?.[currentQuestion] || !Array.isArray(subjects)) return;

  //   const currentQSubjectId = questionData[currentQuestion].subject_id;
  //   const foundSubject = subjects.find(
  //     (s) => Number(s.id) === Number(currentQSubjectId)
  //   );

  //   if (!foundSubject) return;

  //   if (foundSubject.subject_name !== currentSubject) {
  //     if (preTotal(foundSubject.id)) {
  //       setCurrentQuestionBySubject(foundSubject.subject_question_count);
  //     } else {
  //       setCurrentQuestionBySubject(0);
  //     }

  //     setCurrentSubject(foundSubject.subject_name);
  //   }
  // }, [currentQuestion, questionData, subjects, currentSubject]);

  useEffect(() => {
    if (questionData) {
      const subject = subjects.filter(
        (subject) =>
          Number(questionData[currentQuestion].subject_id) ===
          Number(subject.id)
      );
      if (subject[0].subject_name !== currentSubject) {
        setCurrentQuestionBySubject(-1);
        setCurrentSubject(subject[0].subject_name);
        setExpandedSubject(subject[0].subject_name)
      }
    }
  }, [currentQuestion]);

  return (
    <div>
      <Header />
      <ExamHeader
        subjectName={currentSubject}
        showSubmitModal={showSubmitModal}
        handleCloseSubmitModal={handleCloseSubmitModal}
        handleFinalSubmit={handleFinalSubmit}
        handleFinalSubmitCheck={handleFinalSubmitCheck}
        isTimeUp={isTimeUp}
        stats={stats}
        setIsTimeUp={setIsTimeUp}
        submitError={submitError}
        countdownTime={countdownTime}
        finalSubmitChecked={finalSubmitChecked}
      />
      <div
        style={{
          display: "flex",
          borderBottom: "1px solid black",
        }}
      >
        <QuestionSection
          questionData={questionData}
          currentQuestion={currentQuestion}
          handleOptionChange={handleOptionChange}
          handleSaveNextDefault={handleSaveNextDefault}
          handleMarkReviewDefault={handleMarkReviewDefault}
          handleClearResponse={handleClearResponse}
          selectedOptionId={selectedOptionId}
          handleBack={handleBack}
          currentQuestionBySubject={currentQuestionBySubject}
          setCurrentQuestionBySubject={setCurrentQuestionBySubject}
          handleOpenSubmitModal={handleOpenSubmitModal}
        />
        <Sidebar
          subjects={subjects}
          setCurrentQuestion={setCurrentQuestion}
          setCurrentSubject={setCurrentSubject}
          setSubjectId={setSubjectId}
          currentQuestion={currentQuestion}
          questionData={questionData}
          setCurrentQuestionBySubject={setCurrentQuestionBySubject}
          expandedSubject={expandedSubject}
          setExpandedSubject={setExpandedSubject}
          toggleSubject={toggleSubject}
        />
      </div>
      <SubmissionPopupReLogin
        open={showSubmissionPopupReLogin}
        countdown={countdownByHead}
      />

      <SubmissionPopup
        open={showSubmissionPopup}
        countdown={countdownByHead}
        stats={stats}
      />

      <ServerErrorDialog
        open={showServerErrorDialog}
        onClose={() => setShowServerErrorDialog(false)}
      />

      <FinalSubmissionDialog
        open={showSubmitModal || isTimeUp}
        onClose={handleCloseSubmitModal}
        onSubmit={() => {
          if (isTimeUp) {
            handleFinalSubmit("time");
          } else {
            handleFinalSubmit("user");
          }
        }}
        isTimeUp={isTimeUp}
        stats={stats}
        submitError={submitError}
        countdownTime={countdownTime}
        finalSubmitChecked={finalSubmitChecked}
        onFinalSubmitCheck={handleFinalSubmitCheck}
      />

      <Dialog
        open={openMandatory}
        onClose={() => setOpenMandatory(false)}
        PaperProps={{
          style: {
            minWidth: "400px",
            borderRadius: "12px",
            padding: "16px",
          },
        }}
      >
        <img
          src={oip}
          style={{ height: 60, width: 60, margin: "auto" }}
          alt=""
        />
        <DialogTitle
          sx={{
            textAlign: "center",
            padding: "16px 24px",
            display: "flex",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Warning
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ textAlign: "center", padding: "16px 24px" }}>
          <Typography variant="body1">
            All questions are mandatory. Please attempt all of them.
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "center",
            padding: "16px 24px",
            gap: "16px",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setOpenMandatory(false)}
            sx={{
              minWidth: "120px",
              textTransform: "none",
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default FeedbackTest;
